import gql from 'graphql-tag';

export const GET_STAGES_TIMELINE = gql`
  query GetStagesTimeline($departmentId: ID!, $parentId: ID!, $parentType: BPFLinkType!) {
    bpf {
      result: template(id: $departmentId) {
        stages {
          name
          fieldValues(parentId: $parentId, parentType: $parentType) {
            isCompleted
            completedDateTime
            completedBy {
              fullName
            }
          }
        }
      }
    }
  }
`;
